<template>
  <!--srcviewscompanydetailsbusinessvuehtmlStart-->

  <div id="defaultId1" class="company_detail">
    <div id="cc18ed" class="udb507 u22483 pb20">
      <div id="g2ede8" class="operations-content mb10">
        <h2 id="gf7b16" class="operations-head detail_title_20">
          {{ $t("ContentTabs.Industry") }}
        </h2>
        <div class="operations-box">
          <div class="operations-box-left">
            <el-descriptions :colon="false" :column="1" v-if="IndustryTitle">
              <el-descriptions-item>
                <template slot="label">
                  <div class="operations-label-title">
                    {{ $t("Industry.IndustryTitle") }}
                  </div>
                  <div></div>
                </template>
                <div class="operations-label-text">
                  <div>{{ IndustryTitle }}</div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <el-descriptions
              :colon="false"
              :column="1"
              v-if="IndustryDescription != '-'"
            >
              <el-descriptions-item>
                <template slot="label">
                  <div class="operations-label-title">
                    {{ $t("Industry.IndustryDescription") }}
                  </div>
                  <div></div>
                </template>
                <div class="operations-label-text">
                  <div>{{ IndustryDescription }}</div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div class="operations-box-right">
            <div class="industry-right-box is_body_right">
              <ul>
                <li v-if="ISICCode">
                  <div class="industry-right-box-li-box">
                    <div class="operations-label-title">
                      {{ $t("Industry.ISIC") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ ISICCode }}</div>
                    </div>
                  </div>
                  <div
                    class="industry-right-box-li-box"
                    style="margin-bottom: 0px"
                  >
                    <div class="operations-label-title">
                      {{ $t("Industry.ISICDescription") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ isicCodeDes }}</div>
                    </div>
                  </div>
                </li>
                <li v-if="NACECode">
                  <div class="industry-right-box-li-box">
                    <div class="operations-label-title">
                      {{ $t("Industry.NACE") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ NACECode }}</div>
                    </div>
                  </div>
                  <div
                    class="industry-right-box-li-box"
                    style="margin-bottom: 0px"
                  >
                    <div class="operations-label-title">
                      {{ $t("Industry.NACEDescription") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ naceCodeDes }}</div>
                    </div>
                  </div>
                </li>
                <li v-if="NAICSCode">
                  <div class="industry-right-box-li-box">
                    <div class="operations-label-title">
                      {{ $t("Industry.NAICS") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ NAICSCode }}</div>
                    </div>
                  </div>
                  <div
                    class="industry-right-box-li-box"
                    style="margin-bottom: 0px"
                  >
                    <div class="operations-label-title">
                      {{ $t("Industry.NAICSDescription") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ naicsCodeDes }}</div>
                    </div>
                  </div>
                </li>
                <li v-if="csicCode">
                  <div class="industry-right-box-li-box">
                    <div class="operations-label-title">
                      {{ $t("Industry.CSIC") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ csicCode }}</div>
                    </div>
                  </div>
                  <div
                    class="industry-right-box-li-box"
                    style="margin-bottom: 0px"
                  >
                    <div class="operations-label-title">
                      {{ $t("Industry.CSICDescription") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ csicCodeDes }}</div>
                    </div>
                  </div>
                </li>
                <li v-if="aaaicCode">
                  <div class="industry-right-box-li-box">
                    <div class="operations-label-title">
                      {{ $t("Industry.AAAIC") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ aaaicCode }}</div>
                    </div>
                  </div>
                  <div
                    class="industry-right-box-li-box"
                    style="margin-bottom: 0px"
                  >
                    <div class="operations-label-title">
                      {{ $t("Industry.AAAICDescription") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ aaaicCodeDes }}</div>
                    </div>
                  </div>
                </li>
                <li v-if="gicsCode">
                  <div class="industry-right-box-li-box">
                    <div class="operations-label-title">
                      {{ $t("Industry.GICS") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ gicsCode }}</div>
                    </div>
                  </div>
                  <div
                    class="industry-right-box-li-box"
                    style="margin-bottom: 0px"
                  >
                    <div class="operations-label-title">
                      {{ $t("Industry.GICSDescriptio") }}
                    </div>
                    <div class="operations-label-text">
                      <div>{{ gicsCodeDes }}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- tableData.length > 0 -->

      <!-- <PermissionDialog></PermissionDialog> -->
      <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    </div>
  </div>
</template>
<script>
import {
  getCompanyIndustry,
  getIndustryStatics,
  getPartPrivilege,
} from "@/api/companyApi";
import PermissionDialog from "../../../../components/power/PermissionDialog.vue";
import ReLogin from "../../../../components/ReLogin.vue";

export default {
  name: "",
  //   props: {},

  components: {
    PermissionDialog,
    ReLogin,
  },
  created() {
    this.getPartPrivilege();
    this.getList();

    this.$emit("UpdatamarkTotalList", []);
  },
  computed: {},
  data() {
    return {
      reLoginVis: false,
      powerArr: [],
      Busines: "",

      ProductsServices: "",

      options: [],
      YeraOptions: [],
      value1: "2023",
      value2: "",

      tableData: [],
      data: [],

      iconactive: "computer",
      inputIndex: -1,
      editcontent: "",
      IndustryDescription: "",
      IndustryTitle: "",
      csicCode: "",
      gicsCode: "",
      icsCode: "",
      aaaicCode: "",
      ISICCode: "",
      NACECode: "",
      naceCodeDes: "",
      isicCodeDes: "",

      naicsCodeDes: "",
      gicsCodeDes: "",
      csicCodeDes: "",
      aaaicCodeDes: "",
      Employees: "",
      NAICSCode: "",
      isicCode: "",
      selectTypevalue: "",
      // insertData
      // srcviewscompanydetailsbusinessvueDataStart

      // hangyefenxiKey
      hangyefenxiKey: 0,
      echartsdata: [],
      // srcviewscompanydetailsbusinessvueDataEnd
    };
  },
  methods: {
    clickOutSide3() {
      if (this.$refs.upSelect3) {
        this.$refs.upSelect3.visible = false;
      }
    },
    clickOutSide4() {
      if (this.$refs.upSelect4) {
        this.$refs.upSelect4.visible = false;
      }
    },
    getPartPrivilege() {
      getPartPrivilege({
        moduleId: this.$route.query.idpower,
      }).then((res) => {
        this.powerArr[0] = res.data.filter((item) => item.id == "428")[0];
        this.powerArr[1] = res.data.filter((item) => item.id == "429")[0];
      });
    },
    selectType() {
      this.options.map((item) => {
        if (item.id == this.value2) {
          this.selectTypevalue = item.name;
        }
      });
      getIndustryStatics({
        aaaId: this.$route.query.id3a,
        industryCode: this.isicCode,
        filter: this.value2,
        year: this.value1,
      }).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.staticItems;
          let dotCharts = res.data.dotCharts;
          dotCharts.map((item) => {
            if (this.value2 == "4") {
              if (item.yAxis == "3A1") {
                item.Create = "AAA";
              }
              if (item.yAxis == "3A2") {
                item.Create = "AA+";
              }
              if (item.yAxis == "3A3") {
                item.Create = "AA";
              }
              if (item.yAxis == "3A4") {
                item.Create = "AA-";
              }
              if (item.yAxis == "3A5") {
                item.Create = "A+";
              }
              if (item.yAxis == "3A6") {
                item.Create = "A";
              }
              if (item.yAxis == "3A7") {
                item.Create = "A-";
              }
              if (item.yAxis == "3A8") {
                item.Create = "BBB+";
              }
              if (item.yAxis == "3A9") {
                item.Create = "BBB";
              }
              if (item.yAxis == "3A10") {
                item.Create = "BBB-";
              }
              if (item.yAxis == "3A11") {
                item.Create = "BB+";
              }
              if (item.yAxis == "3A12") {
                item.Create = "BB";
              }
              if (item.yAxis == "3A13") {
                item.Create = "BB-";
              }
              if (item.yAxis == "3A14") {
                item.Create = "B+";
              }
              if (item.yAxis == "3A15") {
                item.Create = "B";
              }
              if (item.yAxis == "3A16") {
                item.Create = "B-";
              }
              if (item.yAxis == "3A17") {
                item.Create = "CCC";
              }
              if (item.yAxis == "3A18") {
                item.Create = "CC";
              }
              if (item.yAxis == "3A19") {
                item.Create = "C";
              }
            } else {
              item.Create = item.yAxis.replace("3A", "")
                ? item.yAxis.replace("3A", "")
                : "";
            }
          });
          // .slice(0, 100)
          // 收入
          let xAxisnum = dotCharts
            .filter((i) => i.financialIndex == "income" && i.xAxis > 0)
            .map((item) => {
              return [
                item.xAxis * 10000000,
                item.yAxis.replace("3A", "")
                  ? item.yAxis.replace("3A", "")
                  : "",
                item.num,
                0,
                item.Create,
              ];
            });
          //  利润
          let yAxisnum = dotCharts
            .filter((i) => i.financialIndex == "profit" && i.xAxis > 0)
            .map((item) => {
              return [
                item.xAxis * 10000000,
                item.yAxis.replace("3A", "")
                  ? item.yAxis.replace("3A", "")
                  : "",
                item.num,
                0,
                item.Create,
              ];
            });
          // 总资产
          let zAxisnum = dotCharts
            .filter((i) => i.financialIndex == "asset" && i.xAxis > 0)
            .map((item) => {
              return [
                item.xAxis * 10000000,
                item.yAxis.replace("3A", "")
                  ? item.yAxis.replace("3A", "")
                  : "",
                item.num,
                0,
                item.Create,
              ];
            });
          // 资产回报率
          // let wAxisnum = dotCharts.filter(i => i.financialIndex == 'roa' && i.xaxis > 0).map(item => {
          //   return [item.xaxis, item.yaxis.replace('3A', '') ? item.yaxis.replace('3A', '') : '', item.num, 0]
          // })

          const data = [xAxisnum, yAxisnum, zAxisnum];

          this.echartsdata = data;
          this.$nextTick(() => {
            // 在 DOM 更新后执行代码
            this.industryEchart();
            this.IndustryStatisticschart();
          });
        }
      });
    },
    getList() {
      getCompanyIndustry({
        id3a: this.$route.query.id3a,
      })
        .then((res) => {
          if (res.code == 200) {
            this.IndustryDescription = res.data.industryDescription;
            this.IndustryTitle = res.data.industryTitle;
            this.gicsCode = res.data.gicsCode;
            this.csicCode = res.data.csicCode;
            this.icsCode = res.data.icsCode;
            this.aaaicCode = res.data.aaaicCode;
            this.ISICCode = res.data.isicCode;
            this.isicCode = res.data.isicCode;
            this.NAICSCode = res.data.naicsCode;
            this.NACECode = res.data.naceCode;
            this.naceCodeDes = res.data.naceCodeDes;
            this.isicCodeDes = res.data.isicCodeDes;
            this.csicCodeDes = res.data.csicCodeDes;
            this.naicsCodeDes = res.data.naicsCodeDes;
            this.aaaicCodeDes = res.data.aaaicCodeDes;
            this.gicsCodeDes = res.data.gicsCodeDes;
            this.Employees = res.data.employees;
            this.YeraOptions = res.data.yearFilter;
            this.value1 = this.YeraOptions[0].id;
            this.options = res.data.selectConditions;
            this.value2 = res.data.selectConditions[0].id;
            this.selectTypevalue = res.data.selectConditions[0].name;
            this.tableData = res.data.staticItems;
            // .slice(0, 150)
            let dotCharts = res.data.dotCharts;
            dotCharts.map((item) => {
              if (this.value2 == "4") {
                if (item.yAxis == "3A1") {
                  item.Create = "AAA";
                }
                if (item.yAxis == "3A2") {
                  item.Create = "AA+";
                }
                if (item.yAxis == "3A3") {
                  item.Create = "AA";
                }
                if (item.yAxis == "3A4") {
                  item.Create = "AA-";
                }
                if (item.yAxis == "3A5") {
                  item.Create = "A+";
                }
                if (item.yAxis == "3A6") {
                  item.Create = "A";
                }
                if (item.yAxis == "3A7") {
                  item.Create = "A-";
                }
                if (item.yAxis == "3A8") {
                  item.Create = "BBB+";
                }
                if (item.yAxis == "3A9") {
                  item.Create = "BBB";
                }
                if (item.yAxis == "3A10") {
                  item.Create = "BBB-";
                }
                if (item.yAxis == "3A11") {
                  item.Create = "BB+";
                }
                if (item.yAxis == "3A12") {
                  item.Create = "BB";
                }
                if (item.yAxis == "3A13") {
                  item.Create = "BB-";
                }
                if (item.yAxis == "3A14") {
                  item.Create = "B+";
                }
                if (item.yAxis == "3A15") {
                  item.Create = "B";
                }
                if (item.yAxis == "3A16") {
                  item.Create = "B-";
                }
                if (item.yAxis == "3A17") {
                  item.Create = "CCC";
                }
                if (item.yAxis == "3A18") {
                  item.Create = "CC";
                }
                if (item.yAxis == "3A19") {
                  item.Create = "C";
                }
              } else {
                item.Create = item.yaxis.replace("3A", "")
                  ? item.yaxis.replace("3A", "")
                  : "";
              }
            });
            // 收入
            let xAxisnum = dotCharts
              .filter((i) => i.financialIndex == "income" && i.xaxis > 0)
              .map((item) => {
                return [
                  item.xaxis * 10000000,
                  item.yaxis.replace("3A", "")
                    ? item.yaxis.replace("3A", "")
                    : "",
                  item.num,
                  0,
                  item.Create,
                ];
              });
            //  利润
            let yAxisnum = dotCharts
              .filter((i) => i.financialIndex == "profit" && i.xaxis > 0)
              .map((item) => {
                return [
                  item.xaxis * 10000000,
                  item.yaxis.replace("3A", "")
                    ? item.yaxis.replace("3A", "")
                    : "",
                  item.num,
                  0,
                  item.Create,
                ];
              });
            // 总资产
            let zAxisnum = dotCharts
              .filter((i) => i.financialIndex == "asset" && i.xaxis > 0)
              .map((item) => {
                return [
                  item.xaxis * 10000000,
                  item.yaxis.replace("3A", "")
                    ? item.yaxis.replace("3A", "")
                    : "",
                  item.num,
                  0,
                  item.Create,
                ];
              });
            // 资产回报率
            // let wAxisnum = dotCharts.filter(i => i.financialIndex == 'roa' && i.xaxis > 0).map(item => {
            //   return [item.xaxis, item.yaxis.replace('3A', '') ? item.yaxis.replace('3A', '') : '', item.num, 0]
            // })

            const data = [xAxisnum, yAxisnum, zAxisnum];
            this.echartsdata = data;
            // this.$nextTick(() => {
            //   // 在 DOM 更新后执行代码
            //   this.industryEchart();
            //   this.IndustryStatisticschart()
            // });
          } else {
            this.IndustryDescription = "";
            this.ISICCode = "";
            this.isicCode = "";
            this.NAICSCode = "";
            this.NACECode = "";
            this.Employees = "";
            this.YeraOptions = "";
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },

    edit(content) {
      this.editcontent = content;

      //   this.tableData.push({ ...this.tableData[index-1] });
    },
    // insertMethod
    // srcviewscompanydetailsbusinessvueMethodStart
    // returnPage
    handleEdit(index, row) {},
    IndustryStatisticschart() {
      let dataone = [];
      let datanum = [];
      this.tableData.map((item) => {
        dataone.push(item.subjectCompany);
        datanum.push(item.sameIndustry);
      });

      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.IndustryStatisticschart);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: dataone,
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              // 设置文本的旋转角度
              rotate: 0,
              // 设置文本的最大宽度
              width: 130,
              // 使用 formatter 进行文本处理
              formatter: function (value) {
                // 如果文本长度超过一定值，则进行省略
                return value.length > 5 ? value.substring(0, 5) + "..." : value;
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "Direct",
            type: "bar",
            barWidth: "60%",
            data: datanum,
            barWidth: "80px", // 柱子宽度
            itemStyle: {
              color: "#1290C9", // 柱子颜色
            },
          },
        ],
      };
      this.echartsBox.setOption(option);
    },

    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },
    addInput(index) {
      this.inputIndex = index;
      this.tableData.push({ ...this.tableData[index - 1] });
    },
    initCharStyle() {
      // 初始化图表的样式
      let wt = document
        .querySelector(".supply_chart2")
        .getBoundingClientRect().width;
      let ht = document
        .querySelector(".supply_chart2")
        .getBoundingClientRect().height;
      document.querySelector(".supply_chart2").style.width = wt + "px"; // 强制添加样式
      document.querySelector(".supply_chart2").style.height = ht + "px";
      document.querySelector(".supply_chart1").style.width = wt + "px"; // 强制添加样式
      document.querySelector(".supply_chart1").style.height = ht + "px";
    },
    async industryEchart() {
      let data = this.echartsdata;
      let that = this;

      this.initCharStyle(); // 把尺寸大小都计算好之后，然后再渲染图表内容
      await this.$nextTick(); // 等待DOM更新

      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      let copyCompany = JSON.parse(
        localStorage.getItem("CompanyBase"),
      ).companyName;

      const option = {
        grid: {
          left: "3%",
          right: "5%",
          bottom: "0%",
          top: "10%",
          containLabel: true,
        },
        color: ["#0064d2", "#f5af02", "#86b817"],
        tooltip: {
          // trigger: 'axis',
          showDelay: 0,
          formatter: function (params) {
            if (params.color === "#DD5145") {
              if (params.value[0] < 1000000) {
                return (
                  "Subject Company: " +
                  copyCompany +
                  "<br/>" +
                  params.seriesName +
                  "：" +
                  (params.value[0] / 1000).toFixed(2) +
                  (params.seriesName == "roa" ? "%<br/>" : "k<br/>") +
                  that.selectTypevalue +
                  "" +
                  params.value[1]
                );
              } else if (
                params.value[0] >= 1000000 &&
                params.value[0] < 1000000000
              ) {
                return (
                  "Subject Company: " +
                  copyCompany +
                  "<br/>" +
                  params.seriesName +
                  "：" +
                  (params.value[0] / 1000000).toFixed(2) +
                  (params.seriesName == "roa" ? "%<br/>" : "M<br/>") +
                  that.selectTypevalue +
                  "" +
                  params.value[1]
                );
              } else if (
                params.value[0] >= 1000000000 &&
                params.value[0] < 1000000000000
              ) {
                return (
                  "Subject Company: " +
                  copyCompany +
                  "<br/>" +
                  params.seriesName +
                  "：" +
                  (params.value[0] / 1000000000).toFixed(2) +
                  (params.seriesName == "roa" ? "%<br/>" : "B<br/>") +
                  that.selectTypevalue +
                  "" +
                  params.value[1]
                );
              } else {
                return (
                  "Subject Company: " +
                  copyCompany +
                  "<br/>" +
                  params.seriesName +
                  "：" +
                  params.value[0] +
                  "~" +
                  (params.value[0] / 1000000000000).toFixed(2) +
                  (params.seriesName == "roa" ? "%<br/>" : "B<br/>") +
                  that.selectTypevalue +
                  "" +
                  params.value[1]
                );
              }
            } else {
              if (params.value[0] < 1000000) {
                return (
                  params.seriesName +
                  "：" +
                  (params.value[0] / 1000).toFixed(2) +
                  (params.seriesName == "roa" ? "%<br/>" : "k<br/>") +
                  that.selectTypevalue +
                  ": " +
                  "" +
                  params.value[4] +
                  "<br/>" +
                  "Number of Company: " +
                  params.value[2]
                );
              } else if (
                params.value[0] >= 1000000 &&
                params.value[0] < 1000000000
              ) {
                return (
                  params.seriesName +
                  "：" +
                  (params.value[0] / 1000000).toFixed(2) +
                  (params.seriesName == "roa" ? "%<br/>" : "M<br/>") +
                  that.selectTypevalue +
                  ": " +
                  "" +
                  params.value[4] +
                  "<br/>" +
                  "Number of Company: " +
                  params.value[2]
                );
              } else if (
                params.value[0] >= 1000000000 &&
                params.value[0] < 1000000000000
              ) {
                return (
                  params.seriesName +
                  "：" +
                  (params.value[0] / 1000000000).toFixed(2) +
                  (params.seriesName == "roa" ? "%<br/>" : "B<br/>") +
                  that.selectTypevalue +
                  ": " +
                  "" +
                  params.value[4] +
                  "<br/>" +
                  "Number of Company: " +
                  params.value[2]
                );
              } else {
                return (
                  params.seriesName +
                  "：" +
                  params.value[0] +
                  "~" +
                  (params.value[0] / 1000000000000).toFixed(2) +
                  (params.seriesName == "roa" ? "%<br/>" : "B<br/>") +
                  that.selectTypevalue +
                  ": " +
                  "" +
                  params.value[4] +
                  "<br/>" +
                  "Number of Company: " +
                  params.value[2]
                );
              }
            }
          },
        },
        xAxis: {
          show: true,
          type: "log",
          scale: true,
          max: 100000000,
          min: 1000,
          axisLabel: {
            show: true,
            // formatter: '{value}',
            formatter: (value) => {
              if (value < 1000000) {
                return value / 1000 + "k";
              } else if (value < 1000000000) {
                return value / 1000000 + "m";
              } else if (value > 1000000000000) {
                return value / 1000000000 + "b";
              } else {
                return value / 1000000000 + "b";
              }
            },
            color: "#8398BB",
          },
          splitLine: {
            lineStyle: {
              width: 1,
              type: "dashed",
              color: "#8398BB",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "#142746",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          // max: that.value2=='2'?'2025':'',
          min: that.value2 == "2" ? "2010" : 1,
          // splitNumber: 4,
          inverse: true,
          splitLine: {
            lineStyle: {
              width: 1,
              type: "dashed",
              color: "#8398BB",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "#142746",
            },
          },
          axisLabel: {
            fontSize: 18,
            color: "#8398BB",
            // 后期单位
            formatter: function (value) {
              if (that.value2 == "4") {
                if (value == 1) {
                  return "AAA";
                }
                if (value == 2) {
                  return "AA+";
                }
                if (value == 3) {
                  return "AA";
                }
                if (value == 4) {
                  return "AA-";
                }
                if (value == 5) {
                  return "A+";
                }
                if (value == 6) {
                  return "A";
                }
                if (value == 7) {
                  return "A-";
                }
                if (value == 8) {
                  return "BBB+";
                }
                if (value == 9) {
                  return "BBB";
                }
                if (value == 10) {
                  return "BBB-";
                }
                if (value == 11) {
                  return "BB+";
                }
                if (value == 12) {
                  return "BB";
                }
                if (value == 13) {
                  return "BB-";
                }
                if (value == 14) {
                  return "B+";
                }
                if (value == 15) {
                  return "B";
                }
                if (value == 16) {
                  return "B-";
                }
                if (value == 17) {
                  return "CCC";
                }
                if (value == 18) {
                  return "CC";
                }
                if (value == 19) {
                  return "C";
                }
              } else {
                return value;
              }

              // 不进行千分位格式化
            },
          },
          axisTick: {
            show: false,
          },
        },
        legend: {
          right: "10%",
          data: ["Revenue", "Earning", "Total Assets"],
          textStyle: {
            fontSize: 14,
          },
        },
        series: [
          {
            name: "Revenue",
            data: data[0],
            type: "scatter",
            itemStyle: {
              color: function (params) {
                if (params.data && params.data[3] === "1") {
                  return "#DD5145";
                } else {
                  return params.color;
                }
              },
            },
            symbolSize: function (data) {
              if (data && data[2]) {
                return Math.log(data[2]) + 12;
              }
              return 8;
            },
          },
          {
            name: "Earning",
            data: data[1],
            type: "scatter",
            itemStyle: {
              color: function (params) {
                if (params.data && params.data[3] === "1") {
                  return "#DD5145";
                } else {
                  return params.color;
                }
              },
            },
            symbolSize: function (data) {
              if (data && data[2]) {
                return Math.log(data[2]) + 13;
              }
              return 8;
            },
          },
          {
            name: "Total Assets",
            data: data[2],
            type: "scatter",
            itemStyle: {
              shadowBlur: 6,
              shadowColor: "rgba(68, 99, 1567, 0.45)",
              shadowOffsetY: 4,
              opacity: 1,
              color: function (params) {
                if (params.data && params.data[3] === "1") {
                  return "#DD5145";
                } else {
                  return params.color;
                }
              },
            },
            symbolSize: function (data) {
              if (data && data[2]) {
                return Math.log(data[2]) + 12;
              }
              return 8;
            },
          },
          // {
          //   name: 'roa',
          //   data: data[3],
          //   type: 'scatter',
          //   itemStyle: {
          //     color: function (params) {
          //       if (params.data && params.data[3] === '1') {
          //         return '#DD5145'
          //       } else {
          //         return params.color
          //       }
          //     }
          //   },
          //   symbolSize: function (data) {
          //     if (data && data[3]) {
          //       return Math.log(data[3]) + 8
          //     }
          //     return 8
          //   }
          // },
        ],
      };
      this.echartsBox.setOption(option);
    },
    // srcviewscompanydetailsbusinessvueMethodEnd
  },
};
</script>
<style scoped>
.ua915f {
  margin-right: 0;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 6px;
  padding-bottom: 6px;
  margin-top: 0;
  margin-left: 0;
  margin-bottom: 0;
}

.operations-head {
  font-family: "Arial Bold";
  font-size: 26px;
  color: #1290c9;
  line-height: 27px;
  text-align: left;
  font-style: normal;
}

.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
}

.operations-box {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  gap: 80px;
}

/deep/.el-descriptions__title {
  font-size: 22px;
  font-family: "Arial Bold";
  color: #1a2332;
  text-align: left;
  font-style: normal;
}

/deep/ .el-descriptions-item__label {
  display: block !important;
  margin-right: 30px !important;
}

.operations-label-title {
  width: 130px;
  font-family: "Arial";
  font-size: 20px;
  color: #666666;
  line-height: 26px;
  text-align: left;
  font-style: normal;
  overflow-wrap: break-word;
  word-break: keep-all;
  white-space: normal;
}

.is_body_right .operations-label-title {
  width: 180px !important;
  min-width: 180px;
  flex-shrink: 0;
  font-family: "Arial";
  font-size: 20px;
  color: #666666;
  line-height: 26px;
  text-align: left;
  font-style: normal;
}

.is_body_right .operations-label-text {
  text-align: left !important;
}

.operations-label-text {
  flex: 1;
  min-width: 0;
  font-family: "Arial";
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  text-align: justify;
  text-justify: inter-word;
  font-style: normal;
  word-break: break-word;
}

.operations-label-text div{
  font-family: "Arial";
}

/deep/ .el-textarea__inner {
  font-size: 16px;
  color: #29445d;
}

.ViewMore {
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 26px;
}

.operations-box-left {
  width: 50%;
}

.jiange {
  color: #cccccc;
  margin: 0 18px;
  font-size: 18px;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 18px;
  color: #1290c9;
  font-style: normal;
  height: 44px;
  background: #f5f5f5;
  border-radius: 22px;
  display: flex;
  align-items: center;
  padding: 3px;
}

.last-colmun {
  padding: 24px 0;
  border-bottom: 1px solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -26px;
  right: 0;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 30px !important;
}

.icon {
  margin: 0 18px;
}

/deep/ .highlight-cell {
  background-color: #f2f5f9 !important;
}

/deep/ .el-table .cell {
  color: #1a2332;
  line-height: 26px;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold";
}

/deep/ .el-table {
  margin-top: 18px;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.table-content {
  height: 50px !important;
  line-height: 50px;
}

.operations-box-right {
  width: 46%;
}

.svgbg {
  background-color: #ffffff;
}

.svgclass {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 38px;
  border-radius: 20px;
}

.operations-box-lefttwo {
  display: flex;
  height: 0px;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 26px 35px;
  height: 100%;
}

.operations-headtwo {
  justify-content: flex-end;
  margin-bottom: 18px;
}

.supply div {
  width: 876px !important;
}

.supply_chart {
  flex: auto;
  height: 0px;
}

.uc1096 {
  width: 62%;
}

.bg-descriptions {
  /* background: #F5F5F5; */
  border-radius: 4px;
}

.industry-right-box li {
  padding: 20px 30px;
  background: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 16px;
}

.industry-right-box-li-box {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 16px;
}

@media screen and (max-width: 1920px) {
  .ua915f {
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .operations-head {
    font-size: 20px;
    line-height: 40px;
  }

  .operations-content {
    padding: 22px 30px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }

  .operations-box {
    margin-top: 15px;
    gap: 60px;
  }

  ::v-deep .el-descriptions__title {
    font-size: 16px;
  }

  ::v-deep .el-descriptions-item__label {
    margin-right: 22px !important;
  }

  .operations-label-title {
    width: 160px;
    font-size: 16px;
    line-height: 20px;
  }

  .is_body_right .operations-label-title {
    width: 144px !important;
    min-width: 136px;
    font-size: 16px;
    line-height: 20px;
  }

  .operations-label-text {
    font-size: 16px;
    line-height: 24px;
  }

  ::v-deep .el-textarea__inner {
    font-size: 14px;
  }

  .ViewMore {
    line-height: 16px;
    margin-left: 20px;
  }

  .jiange {
    margin: 0 14px;
    font-size: 16px;
  }

  .contclass {
    font-size: 16px;
    height: 34px;
    border-radius: 16px;
  }

  .last-colmun {
    padding: 18px 0;
  }

  .dingwei {
    top: -20px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 22px !important;
  }

  .icon {
    margin: 0 14px;
  }

  ::v-deep .el-table .cell {
    line-height: 20px;
  }

  ::v-deep .el-table {
    margin-top: 16px;
  }

  .table-content {
    height: 38px !important;
    line-height: 38px;
  }

  .svgclass {
    height: 28px;
    border-radius: 15px;
  }

  .operations-box-lefttwo {
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.12);
    padding: 20px 26px;
  }

  .operations-headtwo {
    margin-bottom: 14px;
  }

  .supply div {
    width: 658px !important;
  }

  .industry-right-box li {
    padding: 15px 22px;
    margin-bottom: 12px;
  }

  .industry-right-box-li-box {
    gap: 15px;
    margin-bottom: 12px;
  }
}

@media screen and (max-width: 1439px) {
  .ua915f {
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .operations-head {
    font-size: 18px;
    line-height: 20px;
  }

  .operations-content {
    padding: 20px 26px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }

  .operations-box {
    margin-top: 12px;
    gap: 54px;
  }

  ::v-deep .el-descriptions__title {
    font-size: 14px;
  }

  ::v-deep .el-descriptions-item__label {
    margin-right: 20px !important;
  }

  .operations-label-title {
    width: 88px;
    font-size: 14px;
    line-height: 18px;
  }

  .is_body_right .operations-label-title {
    width: 120px !important;
    min-width: 120px;
    font-size: 12px;
    line-height: 18px;
  }

  .operations-label-text {
    font-size: 14px;
    line-height: 20px;
  }

  ::v-deep .el-textarea__inner {
    font-size: 12px;
  }

  .ViewMore {
    line-height: 14px;
    margin-left: 18px;
  }

  .jiange {
    margin: 0 12px;
    font-size: 14px;
  }

  .contclass {
    font-size: 14px;
    height: 30px;
    border-radius: 15px;
  }

  .last-colmun {
    padding: 16px 0;
  }

  .dingwei {
    top: -18px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 20px !important;
  }

  .icon {
    margin: 0 12px;
  }

  ::v-deep .el-table .cell {
    line-height: 18px;
  }

  ::v-deep .el-table {
    margin-top: 12px;
  }

  .table-content {
    height: 32px !important;
    line-height: 32px;
  }

  .svgclass {
    height: 26px;
    border-radius: 12px;
  }

  .operations-box-lefttwo {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);
    padding: 18px 24px;
  }

  .operations-headtwo {
    margin-bottom: 12px;
  }

  .supply div {
    width: 586px !important;
  }

  .industry-right-box li {
    padding: 12px 20px;
    margin-bottom: 10px;
  }

  .industry-right-box-li-box {
    gap: 12px;
    margin-bottom: 10px;
  }
}
</style>
